<div *ngIf="dataLoaded && !isInitializing">
    <div *ngFor="let filter of selectedReportFilterableFields | keyvalue">
        <div class="multiselect mt-3" *ngIf="filter.value.ValueSource == 0 && filter.value.MaxAllowedSelections != 1">
            <label>{{ getLocalizationString(filter.value.DisplayName, filter.value.DisplayName) }}</label>
            <!-- Multi select for static multi select dropdown and this has a max limit -->
            <cxone-multiselect-dropdown
                *ngIf="filter.value.MaxAllowedSelections != -1"
                [ngModel]="selectedStaticFilterableFields[filter.key]"
                [options]="filter.value.StaticValues"
                [label]="'DisplayValue'"
                [primaryKey]="'Value'"
                [bulkOperations]="true"
                (dropdownClosed)="CheckEmpty(filter.key)"
                [placeholder]="getLocalizationString('Select_Items', 'Select items')"
                [maxSelectionLimit]="filter.value.MaxAllowedSelections"
                (selectionChanged)="multiFilterSelected($event, filter.key)">
            </cxone-multiselect-dropdown>
            <!-- Multi select for static multi select dropdown and this has no max limit -->
            <cxone-multiselect-dropdown
                *ngIf="filter.value.MaxAllowedSelections == -1"
                [ngModel]="selectedStaticFilterableFields[filter.key]"
                [options]="filter.value.StaticValues"
                [label]="'DisplayValue'"
                [primaryKey]="'Value'"
                [bulkOperations]="true"
                (dropdownClosed)="CheckEmpty(filter.key)"
                [placeholder]="getLocalizationString('Select_Items', 'Select items')"
                (selectionChanged)="multiFilterSelected($event, filter.key)">
            </cxone-multiselect-dropdown>
        </div>
        <div class="singleSelect mt-3" *ngIf="filter.value.ValueSource == 0 && filter.value.MaxAllowedSelections == 1">
            <label for="{{filter.value.DisplayName.replace(' ','')}}">{{ getLocalizationString(filter.value.DisplayName, filter.value.DisplayName) }}</label>
            <!-- Single select for static filters -->
            <cxone-singleselect-dropdown
                [(ngModel)]="selectedStaticFilterableFields[filter.key][0]"
                [options]="filter.value.StaticValues"
                [label]="'DisplayValue'"
                [placeholder]="getLocalizationString('Select_Item', 'Select item')"
                [primaryKey]="'Value'"
                (selectionChanged)="singleFilterSelected($event, filter.key)">
            </cxone-singleselect-dropdown>
        </div>
        <div class="multiselect mt-3" *ngIf="filter.value.ValueSource == 1 && filter.value.MaxAllowedSelections != 1">
            <label>{{ getLocalizationString(filter.value.DisplayName, filter.value.DisplayName) }}</label>
            <!-- Multi select for dynamic multi select dropdown and this has a max limit -->
            <cxone-multiselect-dropdown
                class="multiselectWithMax"
                *ngIf="filter.value.MaxAllowedSelections != -1"
                [ngModel]="selectedDynamicFilterableFields[filter.key]"
                [options]="filter.value.DynamicValues"
                [label]="'DisplayValue'"
                [primaryKey]="'Value'"
                [bulkOperations]="true"
                (dropdownClosed)="CheckEmpty(filter.key)"
                [placeholder]="getLocalizationString('Select_Items', 'Select items')"
                [maxSelectionLimit]="filter.value.MaxAllowedSelections"
                (selectionChanged)="multiFilterSelected($event, filter.key)">
            </cxone-multiselect-dropdown>
            <!-- Multi select for dynamic multi select dropdown and this has no max limit -->
            <cxone-multiselect-dropdown
                class="multiselectWithoutMax"
                *ngIf="filter.value.MaxAllowedSelections == -1"
                [ngModel]="selectedDynamicFilterableFields[filter.key]"
                [options]="filter.value.DynamicValues"
                [label]="'DisplayValue'"
                [primaryKey]="'Value'"
                [bulkOperations]="true"
                (dropdownClosed)="CheckEmpty(filter.key)"
                [placeholder]="getLocalizationString('Select_Items', 'Select items')"
                (selectionChanged)="multiFilterSelected($event, filter.key)">
            </cxone-multiselect-dropdown>
        </div>
        <div class="singleSelect mt-3" *ngIf="filter.value.ValueSource == 1 && filter.value.MaxAllowedSelections == 1">
            <label>{{ getLocalizationString(filter.value.DisplayName, filter.value.DisplayName) }}</label>
            <!-- Single select for dynamic filters -->
            <cxone-singleselect-dropdown
                class="singleSelect"
                [(ngModel)]="selectedDynamicFilterableFields[filter.key][0]"
                [options]="filter.value.DynamicValues"
                [label]="'DisplayValue'"
                [placeholder]="getLocalizationString('Select_Item', 'Select item')"
                [primaryKey]="'Value'"
                (selectionChanged)="singleFilterSelected($event, filter.key)">
            </cxone-singleselect-dropdown>
        </div>
    </div>
</div>